/** First path segment = app area. `/c/{chatId}` prefix skipped: opening a chat keeps the area. */
export function workspaceAreaOf(pathname: string): string {
  const segments = pathname.split("/").filter((s) => s.length > 0);
  const rest = segments[0] === "c" ? segments.slice(2) : segments;
  return rest[0] ?? "";
}
